import { createSlice } from '@reduxjs/toolkit';
const InitialState = {
    imgColumns: ['product_name_en'],
    tableColumns: ['product_name_en', 'price', 'color', 'volume'],
    waColumns: ['product_name_en', 'product_name_cn'],
    edmSingleTaskHasNewCreated: false,
    edmAiHostingHasNewCreated: false,
};
const mailProductSlice = createSlice({
    name: 'mailProductReducer',
    initialState: InitialState,
    reducers: {
        updateImgColumns: (state, action) => {
            state.imgColumns = action.payload;
        },
        resetImgColumns: state => {
            state.imgColumns = InitialState.imgColumns;
        },
        updateTableColumns: (state, action) => {
            state.tableColumns = action.payload;
        },
        resetTableColumns: state => {
            state.tableColumns = InitialState.tableColumns;
        },
        updateWAColumns: (state, action) => {
            state.waColumns = action.payload;
        },
        resetWAColumns: state => {
            state.waColumns = InitialState.waColumns;
        },
        updateEdmSingleTaskHasNewCreated: (state, action) => {
            state.edmSingleTaskHasNewCreated = action.payload;
        },
        updateEdmAiHostingHasNewCreated: (state, action) => {
            state.edmAiHostingHasNewCreated = action.payload;
        },
    },
});
export const { actions } = mailProductSlice;
export default mailProductSlice.reducer;
